export default "__VITE_ASSET__DWNHACTa__"